import DashboardParameter from './DashboardParameter';

export default DashboardParameter;
